/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_PlaceholderInputs */

const th_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const en_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const ja_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const zh_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const es_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu@ejemplo.com`)
};

const pt_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`voce@exemplo.com`)
};

const id_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anda@contoh.com`)
};

const fr_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vous@exemple.com`)
};

const tl_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ikaw@halimbawa.com`)
};

const vi_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ban@vidu.com`)
};

const ko_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const de_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`du@beispiel.de`)
};

const ru_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vy@primer.ru`)
};

const tr_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`siz@ornek.com`)
};

const it_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu@esempio.com`)
};

const pl_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ty@przyklad.pl`)
};

const uk_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vy@pryklad.com`)
};

const hi_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aap@udaharan.com`)
};

const ar_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const ms_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anda@contoh.com`)
};

const bn_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`apni@udaharan.com`)
};

const zh_tw2_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const zh_hk2_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const ur_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aap@misaal.com`)
};

const fa_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shoma@nemoone.com`)
};

const sw_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wewe@mfano.com`)
};

const nl_email_placeholder = /** @type {(inputs: Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jij@voorbeeld.nl`)
};

/**
* | output |
* | --- |
* | "you@example.com" |
*
* @param {Email_PlaceholderInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_placeholder = /** @type {((inputs?: Email_PlaceholderInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_PlaceholderInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_placeholder(inputs)
	if (locale === "ja") return ja_email_placeholder(inputs)
	if (locale === "zh") return zh_email_placeholder(inputs)
	if (locale === "es") return es_email_placeholder(inputs)
	if (locale === "pt") return pt_email_placeholder(inputs)
	if (locale === "id") return id_email_placeholder(inputs)
	if (locale === "fr") return fr_email_placeholder(inputs)
	if (locale === "tl") return tl_email_placeholder(inputs)
	if (locale === "vi") return vi_email_placeholder(inputs)
	if (locale === "ko") return ko_email_placeholder(inputs)
	if (locale === "de") return de_email_placeholder(inputs)
	if (locale === "ru") return ru_email_placeholder(inputs)
	if (locale === "tr") return tr_email_placeholder(inputs)
	if (locale === "it") return it_email_placeholder(inputs)
	if (locale === "pl") return pl_email_placeholder(inputs)
	if (locale === "uk") return uk_email_placeholder(inputs)
	if (locale === "hi") return hi_email_placeholder(inputs)
	if (locale === "ar") return ar_email_placeholder(inputs)
	if (locale === "ms") return ms_email_placeholder(inputs)
	if (locale === "bn") return bn_email_placeholder(inputs)
	if (locale === "zh-TW") return zh_tw2_email_placeholder(inputs)
	if (locale === "zh-HK") return zh_hk2_email_placeholder(inputs)
	if (locale === "ur") return ur_email_placeholder(inputs)
	if (locale === "fa") return fa_email_placeholder(inputs)
	if (locale === "sw") return sw_email_placeholder(inputs)
	if (locale === "nl") return nl_email_placeholder(inputs)
	return en_email_placeholder(inputs)
});